export const MICROPHONE_DEVICES_CHANGED_EVENT = 'microphoneDevicesChanged';
